module.exports = __webpack_public_path__ + "static/img/i144.45393105.png";